import ZoomCar from "../../assets/images/TechPic/zoomcar.png";
import Shein from "../../assets/images/TechPic/Shein.png";
import BookMyShow from "../../assets/images/TechPic/bookMyShow.jpg";

export const projects = [
  {
    project_name: "ZoomCar",
    project_image: ZoomCar,
    Project_description: [
      " A Web application that provides self-drive car rental service. Car booking using preferred time and date. Location-based Car booking. Integrated Paytm Payment Gateway.",
      "                ",
      "                                             Tech Stack: Ejs, HTML, CSS, Javascript, MongoDB, ExpressJs, NodeJs, Mongoose",
    ],
    github_link: "https://github.com/yashraj-m/ZoomCar-backend",
    deployed_link: "https://zoomcar-backend.herokuapp.com/",
    //  technologies: [EJS, CSS3, JAVASCRIPT, NODE_JS, MONGODB],
    Tech_Stacks: "Ejs, JavaScript, MongoDB, ExpressJs, NodeJs, Mongoose",
  },
  {
    project_name: "Shein",
    project_image: Shein,
    Project_description: [
      " A Web Application for fast fashion E-commerce application",
      "Provide a lot designed clothing and beautiful product",
      "Product Showcase, Slideshow, Banners etc.",
      "Login, Sign up,flash Timer, Cart functionality",
      "  ",
      "  Tech Stack: HTML, CSS, Javascript, Json Local Storage",
    ],
    github_link: "https://github.com/Ranjan1501/SHEIN-Project",
    deployed_link: "https://sheinclone.netlify.app",
    //  technologies: [HTML5, CSS3, JAVASCRIPT, REACT],
  },

  {
    project_name: "BookMyShow",
    project_image: BookMyShow,
    Project_description: [
      " A Web Application for tickets sales for movies, show, plays, concerts, sporting Events via online Platform",
      "Provide tickets booking for movies, show, plays etc. for available screening time",
      "Google auth for login no with google security.",
      "Paytm Payment gateway for secure and safe payment",
      "  ",
      "  Tech Stack: ReactJs, Tailwind CSS, HTML, Javascript, MongoDb, NodeJs, ExpressJs, Mongoose",
    ],
    github_link: "https://github.com/Ranjan1501/book-my-show03",
    deployed_link: "https://bookmyshow02.netlify.app/",
    //  technologies: [HTML5, CSS3, JAVASCRIPT, REACT],
  },
];
